// React
import React, { useState, useEffect } from "react";

// Material UI
import {
    Box,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    CircularProgress,
} from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";

// Custom button
import Button from "components/CustomButtons/Button.js";

export default function HeaderSection({
    step_title,
    step_description,
    version,
    onVersionChange,       // (val) => void
    versionOptions = [],   // [{ version, timestamp }]
    onDownload,            // () => void
    downloadLoader = false,
    isMultiSelect = false,
    dropdownLabel = "",
    dropdownOptions = [],          // array of strings
    onSelectedOptionChange,        // (array) => void
}) {
    // --- Local state only ---
    const [selectedOptions, setSelectedOptions] = useState([]);
    useEffect(() => {
        setSelectedOptions([])
    }, [step_title]);

    const handleLeftChange = (e) => {
        let values = Array.isArray(e.target.value) ? e.target.value : [e.target.value];

        if (!isMultiSelect) {
            values = [values[values.length - 1]]; // enforce single
        }

        setSelectedOptions(values);
        if (onSelectedOptionChange) onSelectedOptionChange(values);
    };

    const handleVersionChange = (e) => {
        if (onVersionChange) onVersionChange(e.target.value);
    };

    return (
        <Box mb={1}>
            <Grid container alignItems="center" spacing={2}>
                {/* Left half: Title + Description */}
                <Grid item xs={12} md={6}>
                    <Typography variant="h5">{step_title}</Typography>
                    <Typography variant="body1">{step_description}</Typography>
                </Grid>

                {/* Right half: dropdowns + download */}
                <Grid item xs={12} md={6}>
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        wrap="nowrap"
                        justify={dropdownLabel ? "space-between" : "flex-end"}
                    >
                        {/* Left dropdown */}
                        {dropdownLabel && (
                            <Grid item xs style={{ flexGrow: 1 }}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>{dropdownLabel}</InputLabel>
                                    <Select
                                        multiple={isMultiSelect}
                                        value={selectedOptions}
                                        label={dropdownLabel}
                                        onChange={handleLeftChange}
                                        renderValue={(selected) =>
                                            isMultiSelect ? "" : (selected[0] || "")
                                        }
                                    >
                                        {dropdownOptions.map((opt, idx) => {
                                            const checked = selectedOptions.includes(opt);
                                            return (
                                                <MenuItem key={idx} value={opt}>
                                                    {isMultiSelect && (
                                                        <Checkbox checked={checked} color="primary" />
                                                    )}
                                                    <ListItemText primary={opt} />
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        {versionOptions.length > 0 && (
                            <Grid item style={{ flex: "0 0 auto" }}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 180, maxWidth: 200 }}
                                >
                                    <InputLabel>Select Version</InputLabel>
                                    <Select
                                        label="Select Version"
                                        value={version}
                                        onChange={handleVersionChange}
                                        renderValue={(selected) => `Version: ${selected}`}
                                    >
                                        {versionOptions.map((opt, idx) => (
                                            <MenuItem key={idx} value={opt.version}>
                                                <div>
                                                    <Typography variant="body1">{`Version: ${opt.version}`}</Typography>
                                                    <Typography
                                                        variant="caption"
                                                        style={{ fontStyle: "italic" }}
                                                    >
                                                        {`Last Updated: ${new Date(
                                                            opt.timestamp
                                                        ).toLocaleString()}`}
                                                    </Typography>
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        {/* Download button (always shown) */}
                        <Grid item style={{ flex: "0 0 auto" }}>
                            <Button
                                color="quCreateColor"
                                onClick={onDownload}
                                style={{ whiteSpace: "nowrap" }}
                            >
                                {downloadLoader ? <CircularProgress size={16} style={{marginRight: 10}} color="white" /> : <CloudDownload />}&nbsp;Download
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
